import { PlatformType } from 'osn-shared';
import { PlatformLocalizedImagesViewModel } from '../../../shared/components/image-upload-control/image-upload-view-model';
import { LocalizedFormData } from '../../common/localized-form-data';
import { TargetTypeFormData } from '../../common/target-type-form-data';
import { SchedulingControlViewModel } from '../scheduling-control/scheduling-control-view-model';
import { TraySelectorType } from '../tray-selector/tray-selector.enum';
import { ViewModelCommon } from '../view-model-common/view-model-common';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import { Genre } from '../../../domain/genre';

export enum TargetType {
  Page = 'Page',
  ContentGroup = 'ContentGroup',
}

export type GenericTrayFormViewModelType = TrayFormViewModelType.GenreTray | TrayFormViewModelType.StudiosTray;
export type GenericTrayFormViewModel = GenreTrayFormViewModel | StudiosTrayFormValue;

export interface GenericTrayFormViewModelBase extends ViewModelCommon {
  id?: string;
  type: GenericTrayFormViewModelType;
  title: LocalizedFormData<string>;
  userSegmentIds: string[];
  countryIds: string[];
  scheduling: SchedulingControlViewModel;
  categoryDetails: CategoryViewModel[];
  platformIds: string[];
}

export interface GenreTrayFormViewModel extends GenericTrayFormViewModelBase {
  type: TrayFormViewModelType.GenreTray;
}

export interface StudiosTrayFormValue extends GenericTrayFormViewModelBase {
  layout: TraySelectorType;
  type: TrayFormViewModelType.StudiosTray;
}

export interface CategoryViewModel {
  id?: string;
  name: LocalizedFormData<string>;
  contentTarget: TargetTypeFormData;
  images: PlatformLocalizedImagesViewModel<
    | PlatformType.Web
    | PlatformType.Mobile
    | PlatformType.Tablet
    | PlatformType.BigScreen
    | 'BIGSCREEN  - Keyart'
    | 'BIGSCREEN  - Title treatment'
  >;
  marketingLabel: LocalizedFormData<string>;
  genres?: Genre[];
}
